// extracted by mini-css-extract-plugin
export default {"nav":"AppNav_nav__eH+tu"};